import type { FC } from 'react';

export interface Props {
  title?: string;
}

const SisuPageHead: FC<Props> = ({ title }) => {
  if (!title) {
    return null;
  }
  return (
    <head>
      <title>{title}</title>
    </head>
  );
};
SisuPageHead.displayName = 'SisuPageHead';

export default SisuPageHead;
